export const isPlayPage = (pathname?: string) => {
  if (pathname === undefined) {
    return false
  }

  return pathname.includes('/play') && !pathname.includes('/play-')
}
